import { hookstate } from '@hookstate/core'
import { CompleteObjectDefinition, modelTypes } from './mesh-maker'

export const geometryStateObject = {
  type: 'geometry',
  objects: [] as CompleteObjectDefinition[],
}

export const geometryState = hookstate(geometryStateObject)
